import { NgModule } from '@angular/core';
import { Routes, CanActivate } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { KycComponent } from './layouts/kyc/kyc.component';
import { AdminComponent } from './layouts/admin/admin.component';

// BUYER
import { BuyerComponent } from './layouts/buyer/buyer.component';
// SELLER
import { SellerComponent } from './layouts/seller/seller.component';
// BANKER
import { BankerComponent } from './layouts/banker/banker.component';
// uw bankker UwBankerComponent
import { UwBankerComponent } from './layouts/uw-banker/uw-banker.component';

//chanel 
import { ChannelLayoutComponent } from './layouts/channel/channel-layout/channel-layout.component';
// sale 
import { SalesComponent } from './layouts/sales/sales.component'

import { AuthGuardService as AuthGuard } from './auth-guard.service';
import { from } from 'rxjs';
import { RmLayoutComponent } from './layouts/rm-layout/rm-layout.component';
export const Approutes: Routes = [
  // {
  //   path: '',
  //   component: FullComponent,
  //   children: [
  //   ]
  // },KYCModule
  {
    path: '',
    component: BlankComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', loadChildren: './onboarding/login/login.module#LoginModule' },
      { path: 'register', loadChildren: './onboarding/newRegister/new_register.module#NewRegisterModule' },
      { path: 'user/reset_password/:param1/:param2', loadChildren: './onboarding/resetPswd/resetPswd.module#ResetModule' },
      { path: 'user/confirm_email/:data', loadChildren: './onboarding/verficationPage/verification.module#VerificationModule' },
      // 
      { path: 'user/reject_token/:data', loadChildren: './onboarding/verfication_CP_R/verificationCPR.module#VerificationCPRModule' },
      { path: 'user/approve_token/:data', loadChildren: './onboarding/verfication_CP_A/verificationCPA.module#VerificationCPAModule' }
      // 
    ]
  },
  {
    path: '',
    component: KycComponent,
    children: [
      { path: 'user/role', loadChildren: './KYC/user_role/role.module#RoleModule', canActivate: [AuthGuard] },
      { path: 'user/kyc/:data', loadChildren: './KYC/user_kyc/user_kyc.module#KYCModule', canActivate: [AuthGuard] },
      { path: 'banker/kyc', loadChildren: './KYC/banker_kyc/banker_kyc.module#BankerKYCModule', canActivate: [AuthGuard] },
      { path: 'nbfc/kyc', loadChildren: './KYC/NBFC_kyc/NBFC_kyc.module#NBFCKYCModule', canActivate: [AuthGuard] },
      { path: 'user/saved_KYC/:data', loadChildren: './KYC/saved_user_kyc/saved_user_kyc.module#SavedKYCModule', canActivate: [AuthGuard] },
      { path: 'kyc/upload', loadChildren: './KYC/upload_doc/doc.module#DocumentModule', canActivate: [AuthGuard] },
      { path: 'retailer/kyc', loadChildren: './KYC/retailer-kyc/retailer_kyc.module#RetailerKYCModule', canActivate: [AuthGuard] },
      { path: 'channel/kyc', loadChildren: './KYC/channel-kyc/channel_kyc.module#ChannelKYCModule' },
      { path: 'corporate/kyc', loadChildren: './KYC/corporate_kyc/corporate_kyc.module#CorporateKYCModule', canActivate: [AuthGuard] },
      // CorporateKYCModule
    ]
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      // UserDetailsModule 
      { path: 'admin/userDetails/:email', loadChildren: './admin/userDetails/userDetails.module#UserDetailsModule', canActivate: [AuthGuard] },

      { path: 'admin/kyc', loadChildren: './admin/admin.module#AdminModule', canActivate: [AuthGuard] },
      { path: 'admin/kycDetails/:email', loadChildren: './admin/adminKYC.module#AdminKYCModule', canActivate: [AuthGuard] },
      { path: 'admin/sector_kycDetails/:email', loadChildren: './admin/categoryKYC.module#CategoryKYCModule', canActivate: [AuthGuard] },
      { path: 'admin/distributor', loadChildren: './admin/lender/lender.module#LenderModule', canActivate: [AuthGuard] },
      { path: 'admin/lender', loadChildren: './admin/lender-component/lender.module#AdminLenderModule', canActivate: [AuthGuard] },
      { path: 'admin/users', loadChildren: './admin/users/userList.module#UsersListModule', canActivate: [AuthGuard] },
      { path: 'admin/cam', loadChildren: './admin/cam-user/cam-user.module#CamUserModule', canActivate: [AuthGuard] },
      { path: 'admin/channel', loadChildren: './admin/channel-partner/channel_partner.module#ChannelPartnerModule', canActivate: [AuthGuard] },
      { path: 'admin/super-admin', loadChildren: './admin/super-admin/super-admin.module#SuperAdminModule', canActivate: [AuthGuard] },
      { path: 'admin/manual-super-admin', loadChildren: './admin/super-admin/manual-super-admin.module#ManualSuperAdminModule', canActivate: [AuthGuard] },
      //  ChannelusersModule
      { path: 'admin/channel-users', loadChildren: './admin/channelOnboarded_user/channelUsers.module#ChannelusersModule', canActivate: [AuthGuard] },
      { path: "admin/lender-details/:email", loadChildren: "./admin/lenderDetails/lenderDetails.module#LenderDetailsModule", canActivate: [ AuthGuard, ], },
      // ChannelUserDetailsKYCModule
      { path: 'admin/channel-user-details/:email', loadChildren: './admin/channelOnboarded_user/channelUserDetails.module#ChannelUserDetailsKYCModule', canActivate: [AuthGuard] },
      { path: 'admin/channel-details/:email', loadChildren: './admin/channel-partner/channel_details.module#ChannelDetailsModule', canActivate: [AuthGuard] },
      //Admin onboarding Relationship Manager
      { path: 'admin/rm', loadChildren: './admin/rm/rm.module#RmModule', canActivate: [AuthGuard] },
      // { path: 'admin/rm-onboarding', loadChildren: './admin/rm-onboarding/rm-onboarding.module#RMOnboardingModule', canActivate: [AuthGuard]},



    ]
  },
  // LenderModule
  {
    path: '',
    component: BuyerComponent,
    children: [
      { path: 'buyer/mr', loadChildren: './buyer/material-Request/mr-list.module#BuyerMRListModule', canActivate: [AuthGuard] },
      {
        path: 'buyer/mr/:id', loadChildren: './buyer/material-Request/mr-details.module#BuyerMRDetailsModule',
        canActivate: [AuthGuard]
      },
      { path: 'mr/add', loadChildren: './buyer/material-Request/CreateMR.module#CreateMrModule', canActivate: [AuthGuard] },
      { path: 'buyer/proforma', loadChildren: './buyer/proforma-invoice/PI-list.module#PIListModule', canActivate: [AuthGuard] },
      {
        path: 'buyer/proforma/:id', loadChildren: './buyer/proforma-invoice/PI-detail.module#BuyerPIDetailModule',
        canActivate: [AuthGuard]
      },
      { path: 'buyer/po', loadChildren: './buyer/purchase-order/po-list.module#BuyerPOListModule', canActivate: [AuthGuard] },
      {
        path: 'buyer/po/:id', loadChildren: './buyer/purchase-order/po-details.module#BuyerPODetailsModule',
        canActivate: [AuthGuard]
      },
      { path: 'buyer/invoice', loadChildren: './buyer/invoice/invoice-list.module#InvoiceListModule', canActivate: [AuthGuard] },
      { path: 'buyer/manual_invoice_list', loadChildren: './buyer/invoice/manualInvoice_list.module#InvoiceManualModule', canActivate: [AuthGuard] },

      {
        path: 'buyer/invoice/:id', loadChildren: './buyer/invoice/invoice-details.module#BuyerInvoiceDetailModule',
        canActivate: [AuthGuard]
      },
      { path: 'buyer/agreement', loadChildren: './buyer/agreement/agreement.module#AgreementDistributorModule', canActivate: [AuthGuard] },
      { path: 'buyer/BOE/:id', loadChildren: './buyer/boe/boe-details.module#BuyerBOEModule', canActivate: [AuthGuard] },
      { path: 'buyer/dashboard', loadChildren: './buyer/dashboard/dashboard.module#BuyerDashboardModule', canActivate: [AuthGuard] },
      { path: 'buyer/user-profile', loadChildren: './buyer/user-profile/user-profile.module#BuyerProfileModule', canActivate: [AuthGuard] }

    ]
  },
  {
    path: '',
    component: SellerComponent,
    children: [
      { path: 'seller/inventory', loadChildren: './seller/inventory/inventory.module#InventoryModule', canActivate: [AuthGuard] },
      { path: 'seller/addInventory', loadChildren: './seller/inventory/addInventory.module#AddInventoryModule', canActivate: [AuthGuard] },
      {
        path: 'seller/viewInventory', loadChildren: './seller/inventory/viewInventory.module#ViewInventoryModule',
        canActivate: [AuthGuard]
      },
      { path: 'seller/mr', loadChildren: './seller/material-request/mr-list.module#MRListModule', canActivate: [AuthGuard] },
      { path: 'seller/mr/:id', loadChildren: './seller/proforma-invoice/PI.module#PIModule', canActivate: [AuthGuard] },
      {
        path: 'seller/proforma', loadChildren: './seller/proforma-invoice/PI-list.module#SellerPIListModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'seller/proforma/:id', loadChildren: './seller/proforma-invoice/PI-detail.module#SellerPIDetailModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'seller/po', loadChildren: './seller/purchase-order/po-list.module#SellerPOListModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'seller/po/:id', loadChildren: './seller/purchase-order/po-details.module#SellerPODetailModule',
        canActivate: [AuthGuard]
      },
      { path: 'seller/invoice', loadChildren: './seller/invoice/invoice-list.module#InvoiceListModule', canActivate: [AuthGuard] },
      {
        path: 'seller/invoice/:id', loadChildren: './seller/invoice/invoice-details.module#SellerInvoiceDetailModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'seller/payment-details/:id', loadChildren: './seller/payments/paymentDetails.module#SellerPaymentDetailsModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'seller/manual_invoice_list', loadChildren: './seller/invoice/manual_invoice_list.module#ManualInvoiceListModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'seller/manual_invoice', loadChildren: './seller/invoice/invoice-add.module#InvoiceAddModule',
        canActivate: [AuthGuard]
      },
      { path: 'seller/BOE/:id', loadChildren: './seller/boe/createBOE.module#SellerBOEModule', canActivate: [AuthGuard] },
      {
        path: 'seller/invoiceDiscount', loadChildren: './seller/discounted-invoice/discounted-invoice-list.module#InvoiceDiscountModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'seller/invoiceDiscount/:id',
        loadChildren: './seller/discounted-invoice/discounted-invoice-details.module#DiscountDetailsModule', canActivate: [AuthGuard]
      },
      { path: 'seller/dashboard', loadChildren: './seller/dashboard/dashboard.module#SellerDashboardModule', canActivate: [AuthGuard] },
      { path: 'seller/reconciliation', loadChildren: './seller/payments/payments.module#PaymentListModule', canActivate: [AuthGuard] },
      { path: 'seller/invoice/add', loadChildren: './seller/invoice/invoice-add.module#InvoiceAddModule', canActivate: [AuthGuard] },
      { path: 'seller/list/retailer', loadChildren: './seller/Distributer-Retailer/lender-uw.module#LenderuwModule', canActivate: [AuthGuard] },
      { path: 'seller/agreement', loadChildren: './seller/agreement/agreement.module#AgreementDistributorModule', canActivate: [AuthGuard] },
      { path: 'seller/user-profile', loadChildren: './seller/user-profile/user-profile.module#UserProfileModule', canActivate: [AuthGuard] }
    ]
  },
  {
    path: '',
    component: BankerComponent,
    children: [
      { path: 'banker/invoiceDiscount', loadChildren: './banker/bills/bills-list.module#BankerBillListModule', canActivate: [AuthGuard] },
      { path: 'banker/manualinvoiceDiscount', loadChildren: './banker/bills/manual-bills-list.module#ManualBankerBillListModule', canActivate: [AuthGuard] },
      {
        path: 'banker/invoiceDiscount/:id', loadChildren: './banker/bills/bill-details.module#BankerBillDetailsModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'banker/invoiceDiscount/lodgement/:id', loadChildren: './banker/bills/lodging.module#LodgingModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'invoiceDiscount/add', loadChildren: './banker/discounting/discounting.module#BankerBillDiscountingModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'invoiceDiscount/liquidation', loadChildren: './banker/liquidation/liquidation.module#LiquidationModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'banker/report', loadChildren: './banker/reports/report/report.module#ReportsModule',
        canActivate: [AuthGuard]
      },
      // NewReportsModule
      {
        path: 'banker/reports', loadChildren: './banker/reports/new-report/newReport.module#NewReportsModule',
        canActivate: [AuthGuard]
      },
      { path: 'banker/dashboard', loadChildren: './banker/dashboard/dashboard.module#BankerDashboardModule', canActivate: [AuthGuard] },
      {
        path: 'invoiceDiscount/transaction',
        loadChildren: './banker/TransactionMaintenance/Transaction.module#BankerTransactionModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'banker/disbursed_Invoices',
        loadChildren: './banker/disbursed-invoice/disburse_invoice.module#DisburseInvoiceModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'banker/invoice/:id', loadChildren: './banker/bills/invoice-details.module#BankerInvoiceDetailsModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'invoiceDiscount/transaction/add',
        loadChildren: './banker/TransactionMaintenance/createTxn.module#BankerCreateTransactionModule',
        canActivate: [AuthGuard]
      },
      { path: 'banker/sme-rms', loadChildren: './banker/riskManagementSystem/rms.module#RMSModule', canActivate: [AuthGuard] },
      { path: 'banker/list/uw', loadChildren: './banker/banker-uw/banker-uw.module#BankerUwModule', canActivate: [AuthGuard] },
      { path: 'banker/approver/limit', loadChildren: './banker/limit/limit.module#LimitModule', canActivate: [AuthGuard] },
      { path: 'banker/sign-desk', loadChildren: './banker/sign-desk/signDesk.module#signDeskModule', canActivate: [AuthGuard] },
      { path: 'banker/sign-desk/agreement/:id', loadChildren: './banker/sign-desk/agreement.module#AgreementModule', canActivate: [AuthGuard] },
      { path: 'banker/user-profile', loadChildren: './banker/banker-profile/banker-profile.module#BankerProfileModule', canActivate: [AuthGuard] }
      // BuyerProfileModule


    ]
  },
  {
    path: '',
    component: UwBankerComponent,
    children: [
      { path: 'uw/user-profile', loadChildren: './uw-banker/dashboard/uwdashboard.module#UWBankerDashboardModule' },
      { path: 'uw/limit', loadChildren: './uw-banker/limit/limit.module#LimitModule' },
      // { path: 'admin/sector_kycDetails/:email', loadChildren: './admin/categoryKYC.module#CategoryKYCModule'}
    ]
  },
  {
    path: '',
    component: ChannelLayoutComponent,
    children: [

      { path: 'channel/channel-dashboard', loadChildren: './channel/channel-dashboard/channel_dashboard.module#ChannelDashboardModule', canActivate: [AuthGuard] },
      { path: 'channel/customer-onboarding', loadChildren: './channel/channel-onboarding/channel_onboarding.module#ChannelOnboardingModule', canActivate: [AuthGuard] },
      { path: 'channel/anchor', loadChildren: './channel/anchor/anchor.module#AnchorModule', canActivate: [AuthGuard] },
      { path: 'channel/counter-party', loadChildren: './channel/counter-party/counterParty.module#CounterPartyModule', canActivate: [AuthGuard] },
      { path: 'channel/anchor/:data', loadChildren: './channel/userDetails/anchorDetails.module#AnchorDetailsModule', canActivate: [AuthGuard] },
      { path: 'channel/counter-party/:data', loadChildren: './channel/userDetails/counterPartyDetails.module#CounterPartyDetailsModule', canActivate: [AuthGuard] },
      { path: "channel/user-profile", loadChildren: "./channel/channel-profile/channel-profile.module#ChannelProfileModule", canActivate: [AuthGuard], },
    ]
  },

  {
    path: '',
    component: RmLayoutComponent,
    children: [

      { path: 'rm/rm-dashboard', loadChildren: './rm/rm-dashboard/rm-dashboard.module#RMDashboardModule', canActivate: [AuthGuard] },
      { path: 'rm/customer-onboarding', loadChildren: './rm/rm-onboarding/rm-onboarding.module#RMOnboardingModule', canActivate: [AuthGuard] },
      { path: 'rm/anchor', loadChildren: './rm/anchor/anchor.module#RMAnchorModule', canActivate: [AuthGuard] },
      { path: 'rm/counter-party', loadChildren: './rm/counter-party/counter-party.module#RMCounterPartyModule', canActivate: [AuthGuard] },
      { path: 'rm/anchor/:data', loadChildren: './rm/userDetails/anchorDetails.module#RMAnchorDetailsModule', canActivate: [AuthGuard] },
      { path: 'rm/counter-party/:data', loadChildren: './rm/userDetails/counterPartyDetails.module#RMCounterPartyDetailsModule', canActivate: [AuthGuard] },

    ]
  },

  {
    path: '',
    component: SalesComponent,
    children: [
      // { path: 'uw/user-profile', loadChildren: './uw-banker/dashboard/uwdashboard.module#UWBankerDashboardModule'},
      { path: 'sales/users', loadChildren: './sales/users/usersList.module#UserListModule' },
      // { path: 'admin/sector_kycDetails/:email', loadChildren: './admin/categoryKYC.module#CategoryKYCModule'}
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren:
          './authentication/authentication.module#AuthenticationModule'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/authentication/404'
  }
];
